import Checkbox from './Checkbox.vue';

// @ts-ignore
Checkbox.install = (Vue) => {
  Vue.component((Checkbox as any).options.name, Checkbox);
};

export default Checkbox;
